// @flow
import React, {useMemo} from 'react';
import Box from "@mui/material/Box";
import useUserData from "../../../../../../../hooks/user/useUserData";
import {muiGridLocales} from "../../../../../../../helpers/muiGridLocales";
import {DataGridPremium, GridToolbar, useGridApiRef, useKeepGroupedColumnsHidden} from "@mui/x-data-grid-premium";
import {formatDate} from "../../../../../../../helpers/date";
import dayjs from "dayjs";
import { reportGridsSx } from "../../helpers";

type Props = {};

const VisitsHour = (props: Props) => {
	const {loading, data, t, generalReport} = props
	const {language, dateFormat} = useUserData()
	
	const apiRef = useGridApiRef();
	const initialState = useKeepGroupedColumnsHidden({
		apiRef,
		initialState: {
			density: "standard",
			rowGrouping: {
				model: generalReport ? ['groupingColumn'] : ['exhibitionStartDt']
			},
		},
	});
	
	const columns = useMemo(() => [
			...(generalReport ? [{
				field: 'groupingColumn',
				description: t('Exhibition'),
				headerName: t('Exhibition'),
				width: 800,
			}] : []),
			...(!generalReport ? [{
				field: 'exhibitionStartDt',
				description: t('Exhibition Date'),
				headerName: t('Exhibition Date'),
				width: 280,
				valueFormatter: (value, row, column, apiRef) => {
					return `${formatDate(value, dateFormat)}`
				}
			}] : []),
			{
				field: 'entranceDate',
				description: t('EntranceDate'),
				headerName: t('EntranceDate'),
				flex: 1,
				minWidth: 180,
				valueFormatter: (value, row, column, apiRef) => {
					return (value ? dayjs(value).format(dateFormat) : '')
				}
			},
			{
				field: 'entranceTime',
				description: t('EntranceTime'),
				headerName: t('EntranceTime'),
				flex: 1,
				minWidth: 100,
				valueFormatter: (value, row, column, apiRef) => {
					return value ? dayjs().hour(value).minute(0).format('HH:mm') : ''
				}
			},
			{
				field: 'entranceLobby1Count',
				description: t('EntranceLobby1Count'),
				headerName: t('EntranceLobby1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceLobby2Count',
				description: t('EntranceLobby2Count'),
				headerName: t('EntranceLobby2Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceLoungeCount',
				description: t('EntranceLoungeCount'),
				headerName: t('EntranceLoungeCount'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent1Count',
				description: t('EntranceEvent1Count'),
				headerName: t('EntranceEvent1Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent2Count',
				description: t('EntranceEvent2Count'),
				headerName: t('EntranceEvent2Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent3Count',
				description: t('EntranceEvent3Count'),
				headerName: t('EntranceEvent3Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent4Count',
				description: t('EntranceEvent4Count'),
				headerName: t('EntranceEvent4Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceEvent5Count',
				description: t('EntranceEvent5Count'),
				headerName: t('EntranceEvent5Count'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'entranceCount',
				description: t('EntranceCount'),
				headerName: t('EntranceCount'),
				flex: 1,
				minWidth: 180,
				type: 'number',
			},
			{
				field: 'visitorCount',
				description: t('VisitorCount'),
				headerName: t('VisitorCount'),
				flex: 1,
				minWidth: 220,
				type: 'number',
			},
		],
		[dateFormat, t, generalReport]
	)
	
	return (
		<Box style={{height: 600, width: '100%'}}>
			<DataGridPremium
				apiRef={apiRef}
				sx={reportGridsSx}
				loading={loading}
				initialState={initialState}
				localeText={muiGridLocales(language)}
				rows={data}
				columns={columns}
				slots={{
					toolbar: GridToolbar
				}}
				slotProps={{toolbar: {csvOptions: {disableToolbarButton: true}}}}
				defaultGroupingExpansionDepth={-1}
			/>
		</Box>
	);
};

export default VisitsHour